import styled from 'styled-components';
import { Button } from '../../../components/common/buttons/Button';
import Review from '../../../assets/images/pluvaAutoLanding/user-guide_review.gif';
import Guide from '../../../assets/images/pluvaAutoLanding/user-guide_settings.jpg';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useNavigate } from 'react-router-dom';

export const UserGuideSection = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitleSection>
        <Title>{'실제 농민 사용 후기와\n사용법을 보고싶다면?'}</Title>
      </TitleSection>
      <GuideCard>
        <GuideImage src={Review} />
        <Button
          borderType={'square'}
          color={'filledQuateraryStrong'}
          size={'md'}
          text={{ size: 'md', content: '플루바오토 사용후기 영상 바로가기' }}
          onClick={() => {
            navigate(pageInfo.pluvaAutoBusinessPage.path);
          }}
        />
      </GuideCard>

      <GuideCard>
        <GuideImage src={Guide} />
        <Button
          borderType={'square'}
          color={'filledQuateraryStrong'}
          size={'md'}
          text={{ size: 'md', content: '플루바오토 사용법 영상 바로가기' }}
          onClick={() => {
            navigate(pageInfo.pluvaAutoCustomerServicePage.path);
          }}
        />
      </GuideCard>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const GuideCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const GuideImage = styled.img`
  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;
